export default __webpack_public_path__ + "static/media/spinner.645c2f7f.gif";